import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IListaAnhos, IListaAsignaturas, IListaPeriodos } from 'src/app/interfaces/ponderaciones';
import { environment } from 'src/environments/environment';
import { ISedes } from 'src/app/interfaces/auditoria';
import { IListaJornadas, IBodyListado, IListaReportes } from 'src/app/interfaces/reporte-estado-secciones';
import { IEstados } from 'src/app/interfaces/secciones';

@Injectable({
  providedIn: 'root'
})
export class ReporteEstadoSeccionesService {

  constructor(private http: HttpClient) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getFiltrosAnhos(): Observable<IListaAnhos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-anyos`
    return this.http.get<IListaAnhos>(url, { headers: this.getHeaders() })
  }

  getFiltrosPeriodos(anho: number): Observable<IListaPeriodos> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-periodos?anyo=${anho}`
    return this.http.get<IListaPeriodos>(url, { headers: this.getHeaders() })
  }

  getFiltrosSedes(userId: number): Observable<ISedes> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes?usuario-id=${userId}`
    return this.http.get<ISedes>(url, { headers: this.getHeaders() })
  }

  getFiltrosJornadas(): Observable<IListaJornadas> {
    const  url = `${environment.endpointAdministrativo}/v1/reporte-estado-seccion/obtener-jornadas`
    return this.http.get<IListaJornadas>(url, { headers: this.getHeaders() })
  }

  getFiltrosAsignaturas(anyo:number,periodoId:number,sedeId:number): Observable<IListaAsignaturas> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/buscar-asignatura?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}`
    return this.http.get<IListaAsignaturas>(url, { headers: this.getHeaders() })
  }

  obtenerReporte(idSolicitud: number):Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-estado-seccion/descargar-reporte?proceso-id=${idSolicitud}`
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }

  obtenerListadoReportes(body: IBodyListado):Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-estado-seccion/obtener-listado`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  generarSolicitudReporte(body: IBodyListado):Observable<IListaReportes> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-estado-seccion/genera-reporte`
    return this.http.post<IListaReportes>(url, body, { headers: this.getHeaders() });
  }

  getFiltrosEstados(): Observable<IEstados> {
    const url = `${environment.endpointAdministrativo}/v1/seccion/buscar-estados`
    return this.http.get<IEstados>(url, { headers: this.getHeaders() })
  }
}
